import { CAST_PILOT_ASSISTANT } from '@cast/constants';
import {
  Alert,
  Stack,
  Typography,
  MetadataChipV2,
  tokens,
} from '@cast/design-system';

import type { OverlapInfo } from './proposedPoliciesUtils';

type ProposedPolicyOverlapAlertProps = {
  overlap: OverlapInfo;
};

export const ProposedPolicyOverlapAlert = ({
  overlap,
}: ProposedPolicyOverlapAlertProps) => {
  const { overlapCount, systemPolicyName, movingCount, policyName } = overlap;

  return (
    <Alert
      color="info"
      size="sm"
      noIcon
      testId={`policy-overlap-alert-${policyName}`}
    >
      <Typography variant="P12B" sx={{ mb: 4 }}>
        {overlapCount} of these workloads already match a system policy
      </Typography>
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={4}>
        <Typography
          component="span"
          variant="P12R"
          sx={{ color: tokens.theme.fg.status.onInfoSubtle }}
        >
          {CAST_PILOT_ASSISTANT} detected overlap with the system policy
          {systemPolicyName}. These workloads will stay on their current policy
          — {CAST_PILOT_ASSISTANT} will only move the remaining {movingCount}{' '}
          into
        </Typography>
        <MetadataChipV2
          label={policyName}
          size="xs"
          variant="subtle"
          testId={`policy-overlap-name-${policyName}`}
        />
      </Stack>
    </Alert>
  );
};
